<template>
  <div>
    <b-card
      no-body
      class="p-2 container-card"
    >
      <b-row>
        <b-col
          cols="12"
          class="px-2"
        >
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                v-if="getPermissionModule('Privileges').adjust"
                :btn-label="'Category'"
                @click.native="$router.push('/privilege/category/create')"
              />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="privilege-type-status"
                  v-model="formStatus.status"
                  class="v-select-filter bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="option => onSelectFilter('status', option)"
                />
              </div>
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="privilegeCategoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
                :class="tableModeReorder ? 'table-reorder' : null"
              > -->
              <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="privilegeCategoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical"
                :class="tableModeReorder ? 'table-reorder' : null"
              >
                <template #head(category_image_url)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #head(category_sub_image_url)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #cell(category_image_url)="data">
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.value || DefaultImg"
                      class="image-column"
                    >
                  </div>
                </template>
                <template #cell(category_sub_image_url)="data">
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.value || DefaultImg"
                      class="image-column"
                    >
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="mr-2"
                      :class="resolveStatusClass(data.item.status)"
                    />

                    <span>{{ resolveStatusLabel(data.item.status) }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <action-group
                    v-if="getPermissionModule('Privileges').adjust"
                    :resolve-action="resolveMappingTableAction"
                    :set-action-list="privilegeCategoryActionList"
                    :item-data="data"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col
          cols="12"
        >
          <pagination-with-reorder
            entity-editable
            reordering
            :pagination="pagination"
            @reorder="onClickReorder"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <reorder-modal
      v-if="modalType.reorder"
      :current-index="currentIndex"
      :reorder-action="reorderPrivilege"
      @onCloseModal="onCloseModalPrivilege"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import ActionGroup from '@/views/components/table-action-group/ActionGroup.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'

import AddButton from '@/views/components/button/AddButton.vue'
import Search from '@/views/components/search/Search.vue'
import vSelect from 'vue-select'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import Sortable from 'sortablejs'
import ReorderModal from '@/@core/components/reorder-modal/ReorderModal.vue'
import DefaultImg from '@/assets/images/icons/no-img-square.jpg'
import usePrivilegeCategory from './hooks/usePrivilegeCategory'

const createSortable = (el, options, vnode) => Sortable.create(el, {
  ...options,
})

const sortableRow = {
  name: 'sortableRow',
  bind(el, binding, vnode) {
    const table = el
    table._sortable = createSortable(
      table.querySelector('tbody'),
      binding.value,
      vnode,
    )
  },
}
export default {
  directives: {
    sortableRow,
  },
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    ActionGroup,
    AddButton,
    Search,
    vSelect,
    PaginationWithReorder,
    ReorderModal,
  },
  setup() {
    const {
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      formStatus,
      fields,
      statusOption,
      loading,
      privilegeCategoryTable,
      privilegeCategoryActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      reorderPrivilege,
      onClickReorder,
      currentIndex,
      modalType,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      onCloseModalPrivilege,
      getPermissionModule
    } = usePrivilegeCategory()
    return {
      DefaultImg,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      formStatus,
      fields,
      statusOption,
      loading,
      privilegeCategoryTable,
      privilegeCategoryActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      modalType,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      reorderPrivilege,
      onClickReorder,
      onCloseModalPrivilege,
      getPermissionModule
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/pages/privilege/privilege-list.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
